import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonModal, LoadingController, ModalController, ToastController } from '@ionic/angular';

declare var google: any;
const geoLoc = new google.maps.Geocoder();

@Component({
  selector: 'app-map-geolocation',
  templateUrl: './map-geolocation.component.html',
  styleUrls: ['./map-geolocation.component.scss'],
})
export class MapGeolocationComponent implements AfterViewInit {
  //PARA EXTRAER LA UBICACION
  @ViewChild('map') mapElement: ElementRef;
  marker: any;
  loading: any;
  plusCodeUser: any;
  addressGeocoding: any;    //almacena la direccion encontrada en el proceso de geocodificacion inversa (coordenadas -> dirección)
  @Input() address?: string;
  @Input() cityName?: string;
  @Input() latUser?: number;
  @Input() lngUser?: number;
  @Input() plusCode?: string;
  mapLoaded: any = false;
  constructor(
    public toastController: ToastController,
    public modalController: ModalController,
    public loadingController: LoadingController
  ) { }

  async ngAfterViewInit() {
    // this.askForLocationPermission();
     this.loading = await this.loadingController.create({
       message: '',
       spinner: 'bubbles',
       duration: 3000
     });
     this.loading.present();
     const mapElement = document.getElementById('map');
     if (mapElement && !mapElement.innerHTML.trim()) {  // Verifica que el mapa esté vacío (sin contenido)
       await this.openMap();
     } else {
       console.warn('El mapa ya está en pantalla o no está vacío.');
     }
   }

  async openMap() {
    
    setTimeout(async () => {
      try {
        
      //Si existe latitud y longitud se ubica por ellas
        if (this.latUser && this.lngUser) {
          console.warn('Intentando con latitud y longitud.');
          this.initMap(this.latUser, this.lngUser, 18);
      //Si no existe se ubica por su direccion
        } else if (this.address || this.cityName) {
          let userAddress = `${this.address}, ${this.cityName}`.trim();
          console.log('Geocodificando dirección: ', userAddress);
          const location = await this.geocodeAddress(userAddress);
          await this.initMap(location.lat(), location.lng(), 18);
        } else {
      //Si no hay datos intento ubicar con la ciudad seleccionada
          this.getCityCoordenates().then(async ({ longitud, latitud }) => {
            console.warn('Reintentando con latitud y longitud de la ciudad seleccionada.');
            await this.initMap(latitud, longitud, 12);
          });
          console.warn('No se pudo hacer la geocodificació de la dirección ingresada:');
        }
      } catch (error) {
        console.warn("No se pudo realizar ningúna geolocalizacion..... iniciando mapa con ubicación por defecto", error);
        await this.initMap(4.61744, -74.06884, 10);      // Coordenadas de ubicación predeterminada BOGOTA
      }
    }, 2000);
  }

  async initMap(latitude: number, longitude: number, zoom: number) {
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;
    const map = new Map(                            //CREA UN  NUEVO MAPA
      document.getElementById('map') as HTMLElement,
      {
        zoom: zoom,
        center: { lat: latitude, lng: longitude },
        mapId: 'MAP_ID',
      }
    );
    //CREA UN MARCADOR PARA MOSTRAR EN EL CENTRO DEL MAPA
    this.marker = new google.maps.Marker({
      position: map.getCenter(),
      map: map,
      title: 'marker',
      draggable: true
    });

    //ACTUALIZA EL MARCADOR AL CENTRO MOVER EL MAPA 
    map.addListener('drag', () => { this.marker.setPosition(map.getCenter()); });
    map.addListener('zoom_changed', () => { this.marker.setPosition(map.getCenter()); });
  }

  async setAddress() {        //RECIBE Y DEVUELVE LA UBICACION SELECCIONADA EN EL MARCADOR
    try {
      const posicionMarcador = this.marker.getPosition();
      this.latUser = posicionMarcador.lat();
      this.lngUser = posicionMarcador.lng();
      await this.getPlusCode(this.latUser, this.lngUser);
      console.log('Ubicación Guardada...', this.latUser, this.lngUser, this.plusCodeUser);
      //Se cierra el modal y se regresan sus datos
      this.modalController.dismiss({
        address: this.address,
        plusCode: this.plusCodeUser,
        latitude: this.latUser,
        longitude: this.lngUser
      });
    } catch (error) {
      console.error('No se pudo guardar la ubicación ', error);
    }

  }

  getCityCoordenates(): Promise<any> {
    const request = {
      address: this.cityName
    }
    return new Promise((resolve, reject) => {
      geoLoc.geocode(request, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
          const ubicacion = results[0].geometry.location;
          const longitud = ubicacion.lng();
          const latitud = ubicacion.lat();
          resolve({ longitud, latitud });
        } else {
          reject(new Error(`No se pudo obtener la longitud y latitud para ${this.cityName}`));
        }
      });
    });
  }

  async getPlusCode(latitud: number, longitud: number) {          //EXTRAE EL PLUS CODE POR MEDIO DE LAS COORDENADAS DEL MARCADOR 
    const ubicacion = new google.maps.LatLng(latitud, longitud);
    let plusCode;
    let address;
    const resultado = await new Promise((resolve, reject) => {
      geoLoc.geocode({ 'location': ubicacion }, (results: any, status: any) => {
        if (status === 'OK') {
          resolve(results);
        } else {
          reject(new Error(`Geocoder falló con el estado: ${status}`));
        }
      });
    });
    console.log('Resultado Geodificacion inversa: ', resultado);
    if (resultado && Array.isArray(resultado)) {
      resultado.forEach((addresResult) => {   //recorremos el array de resultados para extraer los datos relevantes
        if (!plusCode) {    //Si no se ha encontrado buscamos
          if (addresResult.types.includes('plus_code')) {    //buscamos en el array el objeto que incluye de tipo Plus_code ya que ahi encontramos el plus code
            console.log('Se encontro el plus code: ', addresResult);
            plusCode = addresResult.formatted_address.split(' ')[0];
          }
        }
        if (!address) {
          if (addresResult.types.includes('street_address')) {
            const indexCity = addresResult.formatted_address.indexOf(',');
            address = addresResult.formatted_address.substring(0, indexCity);
          }
        }
      });
      //verifico que haya extraido los datos para asignarlos
      if (plusCode) {
        this.plusCodeUser = plusCode;         //guarda plus code obtenido en la variable global
      } else {
        console.error("No se encontró el Plus Code en la respuesta.");
      }

      if (address) {
        this.addressGeocoding = address;           //guarda direccion obtenida en la variable global
      } else {
        console.warn('No se encontro direccion exacta validando los demas resultados de la geocodificacion');
        for (const alternAddres of resultado) {   //recorremos el array de resultados para extraer los datos relevantes
          if (alternAddres.types.includes('premise')) {
            this.addressGeocoding = alternAddres.formatted_address;
            break;
          } else if (alternAddres.types.includes('route')) {
            this.addressGeocoding = alternAddres.formatted_address;
            break;
          } else {
            console.error("No se encontró Dirección en la respuesta.");
          }
        };
      }
    }
  }

  async geocodeAddress(address: string): Promise<any> {
    return new Promise((resolve, reject) => {
      geoLoc.geocode({ 'address': address }, (results, status) => {
        if (status === 'OK' && results.length > 0) {
          resolve(results[0].geometry.location);
        } else {
          reject(new Error('Error en el método de geocodificación: ' + status));
        }
      });
    });
  }
  

  askForLocationPermission() {                //SOLICITA LA UBICACION AL USUARIO POR MEDIO DEL NAVEGADOR
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => this.setPosition(position));
    } else {
      console.error('ERROR: La geolocalización no es compatible con el navegador');
    }
  }

  setPosition = async (position: GeolocationPosition) => {     //MUESTRA LA UBICACION Y ASIGNA COORDENADAS
    this.latUser = position.coords.latitude;
    this.lngUser = position.coords.longitude;
    await this.getPlusCode(this.latUser, this.lngUser);
    this.address = this.addressGeocoding;
    console.log('Ubicacion obtenida por localizacion de navegador', this.latUser, this.lngUser, this.plusCodeUser, this.address);
    this.modalController.dismiss({
      address: this.address,
      plusCode: this.plusCodeUser,
      latitude: this.latUser,
      longitude: this.lngUser
    });
  }

  closeMap() {
    const mapElement = document.getElementById('map');
    if (mapElement) {
      mapElement.innerHTML = '';
    }
    this.modalController.dismiss();
  }
}
